<template>
  <div class="">
    <div class="col-12">
      <form @submit.prevent="createNewOffTime">
        <h4>تقویم</h4>
        <div class="row">

          <div class="col-6">

            <form-group :validations="$v.form.open_at">
              <div slot-scope="{ errors, invalid }">
                <label>تاریخ شروع بازه</label>
                <date-picker clearable auto-submit v-model="form.open_at"
                             placeholder="تاریخ شروع بازه"
                             type="datetime"
                />
                <form-errors-manager :errors="errors"/>
              </div>
            </form-group>

          </div>

          <div class="col-6">

            <form-group :validations="$v.form.close_at">
              <div slot-scope="{ errors, invalid }">
                <label>تاریخ پایان بازه</label>
                <date-picker clearable auto-submit v-model="form.close_at"
                             placeholder="تاریخ پایان بازه"
                             type="datetime"
                             :min="form.open_at"/>
                <form-errors-manager :errors="errors"/>
              </div>
            </form-group>


          </div>

          <div class="col-12 text-left my-3">
            <b-btn variant="secondary" type="submit">
              اضافه کردن
            </b-btn>
          </div>

        </div>
      </form>


    </div>
    <div class="my-4">
      <h4>روز های تعطیل</h4>
      <div class="container-fluid p-0 m-0" v-for="(offTime,offTimeIndex) in offTimes">
        <div class="row justify-content-center align-items-center my-3">
          <div class="col">تاریخ شروع: <span dir="ltr">{{ offTime[1] }}</span></div>
          <div class="col">تاریخ پایان: <span dir="ltr">{{ offTime[1] }}</span></div>
          <div class="col">
            <b-btn variant="primary" @click="removeOffTime(offTimeIndex)">
              حذف
            </b-btn>
          </div>
        </div>
        <hr>
      </div>
    </div>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import FormErrorsManager from "@/plugin/components/validator/FormErrorsManager.vue";
import FormGroup from "@/plugin/components/validator/FormGroup.vue";
import {required} from "vuelidate/lib/validators";

export default {
  name: "HourOffTimes",
  components: {FormGroup, FormErrorsManager, datePicker: VuePersianDatetimePicker,},
  data() {
    return {
      form: {
        open_at: '',
        close_at: '',
      },
    }
  },
  props: {
    reservation: {}
  },
  validations: {
    form: {
      open_at: {required},
      close_at: {required},
    }
  },
  computed: {
    offTimes() {
      return this.reservation.reservationRule.off_times
    },
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    createNewOffTime() {
      if (this.invalid()) {
        let newOffTime = [
          this.form.open_at,
          this.form.close_at,
        ]
        this.offTimes.push(newOffTime)
        this.$forceUpdate()
      }
    },
    removeOffTime(offTimeIndex) {
      this.offTimes.splice(offTimeIndex, 1)
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>

</style>